/**
 * Tracks pathname transitions inside /design so hooks can tell "came from finalization".
 * Updated from `DesignLayout` via `useLayoutEffect`.
 */

let previousPathname = '';
let currentPathname = '';

/** @param {string} pathname */
export function syncDesignPathname(pathname) {
  if (!pathname || pathname === currentPathname) return;
  previousPathname = currentPathname;
  currentPathname = pathname;
}

/** Pathname before the last syncDesignPathname change. */
export function getDesignPreviousPathname() {
  return previousPathname;
}

